<template>
 <v-container fluid style="padding-bottom: 0">
  <v-layout style="max-width: 40em; align-items: center">
    <v-text-field
        required
        :label="required ? `${label}*`: label"
        placeholder="Seleccione un archivo"
        readonly
        ref="fileNameInput"
        :error-messages="errorMessages"
        :value="filename"
        :name="name"
         @click="$refs.fileInput.click()"
    ></v-text-field>
    <v-btn :disabled="disabled" icon v-if="!readonly" text @click="$refs.fileInput.click()"><v-icon>attach_file</v-icon></v-btn>
    <input type="file" :accept="accept" ref="fileInput" hidden @change="setValueFile()"/>
  </v-layout>
  </v-container>
</template>

<script>
import fieldMixin from './mixins/fieldMixin';

export default {
  name: 'FileField',
  mixins: [fieldMixin],
  props: {
    accept: {
      type: String,
      required: false
    },
  },
  data: () => ({
    file: null,
    nombreArchivo: ''
  }),
  computed: {
    filename () {
      return this.file === null ? this.value : this.file.name;
    }
  },
  watch: {
    value (val) {
      if (!val) {
        this.file = null;
      }
    }
  },
  methods: {
    setValueFile () {
      this.file = this.$refs.fileInput.files[0];
      this.$refs.fileNameInput.$forceUpdate();
      this.$emit('input', this.file);
    }
  }

};
</script>

<style scoped>

</style>
